import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

/**
 * Single source of truth for the breadcrumb links shared across screens.
 * "Home" always opens the Accounts page, on every channel. "Campaigns"
 * opens that channel's Campaigns list.
 */
export const ACCOUNTS_ROUTE = "/accounts";
export const HOME_ROUTE = ACCOUNTS_ROUTE;
export const CAMPAIGNS_ROUTE = "/amazonads";
export const WALMART_CAMPAIGNS_ROUTE = "/walmartads";

export type Crumb = {
  label: string;
  /** Omit for a crumb that has no page of its own - it renders as plain text. */
  to?: string;
};

type Props = {
  items: Crumb[];
};

/**
 * Renders a breadcrumb trail. Every crumb with a `to` navigates through
 * react-router (never a raw `href`, which reloads the app), the last crumb
 * is always the current page and is never a link.
 */
const PageBreadcrumb = ({ items }: Props) => {
  const crumbs = items.filter(Boolean);

  return (
    <Breadcrumb>
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        if (isLast || !crumb.to) {
          return (
            <Breadcrumb.Item key={`${crumb.label}-${index}`} active={isLast}>
              {crumb.label}
            </Breadcrumb.Item>
          );
        }

        return (
          <Breadcrumb.Item
            key={`${crumb.label}-${index}`}
            linkAs={Link}
            linkProps={{ to: crumb.to }}
          >
            {crumb.label}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default PageBreadcrumb;
